import '../scss/app.scss';

// Carrusel infinito
document.addEventListener('DOMContentLoaded', () => {
    const track = document.getElementById('carouselTrack');

    if (track) {
        // Duplicar las imágenes para efecto infinito
        const slides = Array.from(track.children);
        slides.forEach(slide => {
            const clone = slide.cloneNode(true);
            track.appendChild(clone);
        });

        let position = 0;
        const speed = 1; // pixels por frame
        let slideWidth = track.children[0].offsetWidth;
        let totalWidth = slideWidth * slides.length;
        let animationId = null;

        function animate() {
            position -= speed;

            // Resetear posición sin salto cuando la primera imagen duplicada llegue al borde
            if (Math.abs(position) >= totalWidth) {
                position = position + totalWidth;
            }

            track.style.transform = `translate3d(${position}px, 0, 0)`;
            animationId = requestAnimationFrame(animate);
        }

        // Solo animar si el usuario no tiene preferencia de reducir movimiento
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!prefersReducedMotion) {
            animate();
        }

        // Debounce para recalcular dimensiones al redimensionar
        let resizeTimeout;
        function handleResize() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                slideWidth = track.children[0].offsetWidth;
                totalWidth = slideWidth * slides.length;
            }, 250);
        }

        window.addEventListener('resize', handleResize);
    }
});